/***************************************************************
	*
	GLOBAL UTILITIES (REUSABLE)
	*
***************************************************************/

export function domReady(fn) {
	if ( document.readyState !== 'loading' ) {
		fn();
	} else {
		document.addEventListener('DOMContentLoaded', fn);
	}
}
